import LoaderWheel from "../LoaderWheel";
import { useContext, useEffect, useState } from "react";
import { AppContext } from '../../utils/ContextProvider';
import API from "../../utils/API";
import Swal from 'sweetalert2';
import GlobalSVG from "../../utils/GlobalSVG";
import { Link } from "react-router-dom";
import AlertsMultipleSelect from "../AlertsMultipleSelect";

const MaintenanceActivityLine = (props) => {
    const context = useContext(AppContext);
    const [deleting, setDeleting] = useState(false)
    const [saving, setSaving] = useState(false)
    const [activity, setActivity] = useState()
    const [selectedPoints, setSelectedPoints] = useState([])
    const [showNote, setShowNote] = useState(false)
    const [edit, setEdit] = useState(false)
    const statusColor = { 'Upcoming': '#007b4e', 'Due': '#F9941E', 'Set': '#B8BBB9', 'Overdue': '#F75D5F' }


    useEffect(() => {
        if (!props.activity) return
        setActivity(props.activity)
        if (props.adding) setEdit(true)
    }, [props])

    const handleSave = () => {

        setSaving(true)
        if (props.adding) {

            const promises = selectedPoints.map(point => {
                let tempActivity = { ...activity };
                tempActivity.channel_id = point;
                const found = Object.values(props.equipmentList).find(e => e.channel_id === parseInt(tempActivity.channel_id));
                tempActivity.channel_name = found ? found.channel_name : '';
                tempActivity.maintenance_id = props.maintenanceId;
                return API.createMaintenanceActivity(tempActivity)
                    .then(res => {
                        props.setGroups(prevGroups => {
                            const updatedGroups = prevGroups.map(e => {
                                if (e.id === props.group.id) {
                                    let activities = [...(e.activities || []), { ...res.data, channel_name: tempActivity.channel_name }];
                                    return { ...e, activities };
                                }
                                return e;
                            });

                            // Immediately update numbers based on the new group data
                            props.updateNumbers(updatedGroups);

                            return updatedGroups;
                        });
                    })
                    .catch(e => {
                        console.log(e);
                        Swal.fire({
                            title: 'Oops!',
                            text: 'An error occurred, please try again later.',
                            icon: 'warning',
                            confirmButtonText: 'Ok',
                            confirmButtonColor: '#007b4e',
                        });
                    });
            });

            Promise.all(promises).finally(() => {
                setEdit(false);
                props.setAdding(false);
                setSaving(false);
            });
        } else {
            if (activity.channel_name && !activity.channel_id) activity.channel_id = props.equipmentList[activity.channel_name].channel_id
            if (activity.channel_id && !activity.channel_name) activity.channel_name = Object.values(props.equipmentList).find(e => e.channel_id === parseInt(activity.channel_id)).channel_name
            let allowed = ["channel_id", "threshold_days", "tolerance_days", "threshold_hours", "tolerance_hours", "notes", "timebase"]
            let payload = JSON.parse(JSON.stringify(activity))
            for (let key in payload) {
                if (!allowed.includes(key)) delete payload[key]
            }
            API.updateMaintenanceActivity(payload, activity.id).then(async res => {
                let tempGroups = JSON.parse(JSON.stringify(props.groups))
                let updatedGroups = tempGroups.map(e => {
                    if (e.id === activity.maintenance_id) {
                        let activities = e.activities.filter(e => e.id !== activity.id)
                        activities.push(activity)
                        return { ...e, activities: JSON.parse(JSON.stringify(activities)) };
                    }
                    else return e
                });
                props.setGroups(updatedGroups);
                props.updateNumbers(updatedGroups)
                setEdit(false)
            }).catch(e => {
                console.log(e)
                Swal.fire({
                    title: 'Oops!',
                    text: 'An error occurred, please try again later.',
                    icon: 'warning',
                    confirmButtonText: 'Ok',
                    confirmButtonColor: '#007b4e',
                });
            }).finally(f => {
                setSaving(false)
            })
        }
    }

    const updateActivity = (event) => {
        if (event.target.name === 'circuits') {
            let value = event.target.value
            let list = []
            if (event.target.value === 'all') {
                list = Object.values(props.equipmentList).map(e => parseInt(e.channel_id))
            }
            else if (event.target.value === 'none') {
                list = []
            }
            else {
                let tempList = JSON.parse(JSON.stringify(selectedPoints))
                list = tempList.includes(value) ? tempList.filter(e => e !== value) : [...tempList, parseInt(value)]
            }
            setSelectedPoints(list)
            if (Object.values(props.equipmentList).some(e => list.includes(e.channel_id) && e.untracked)) {
                let tempAct = JSON.parse(JSON.stringify(activity))
                tempAct.timebase = 'days'
                setActivity(tempAct)
            }
            return
        }
        if (event.target.name === "channel_id" && Object.values(props.equipmentList).find(e => e.id === event.target.value)?.untracked) {
            let tempAct = JSON.parse(JSON.stringify(activity))
            tempAct.channel_id = event.target.value
            tempAct.timebase = 'days'
            setActivity(tempAct)
        } else {
            setActivity(e => ({ ...e, [event.target.name]: event.target.value }))
        }
    }

    const handleDelete = (id) => {

        setDeleting(true)
        Swal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to revert this!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
            reverseButtons: true
        }).then((result) => {
            if (result.isConfirmed) {
                API.updateMaintenanceActivity({ deleted: true }, id).then(async res => {
                    let tempGroups = JSON.parse(JSON.stringify(props.groups))
                    let updatedGroups = tempGroups.map(e => {
                        if (e.id === props.group.id) {
                            let activities = e.activities.filter(e => e.id !== activity.id)
                            return { ...e, activities: JSON.parse(JSON.stringify(activities)) };
                        }
                        else return e
                    });
                    props.setGroups(updatedGroups);
                    props.updateNumbers(updatedGroups)
                }).catch(e => {
                    console.log(e)
                    Swal.fire({
                        title: 'Oops!',
                        text: 'An error occurred, please try again later.',
                        icon: 'warning',
                        confirmButtonText: 'Ok',
                        confirmButtonColor: '#007b4e',
                    });
                })
            } else {
                setDeleting(false)
            }
        });
    }

    return (
        <div>
            {
                !edit && showNote &&
                <div className="absolute top-[25vh] left-[25vw] w-[50vw] h-[50vh] z1000 overflow-auto bg-[#f9f9f9] p-[15px] rounded card">
                    <div className="w-full flex flex-nowrap justify-end cursor-pointer">
                        <div onClick={() => setShowNote(false)}>
                            {GlobalSVG.close('black')}
                        </div>
                    </div>
                    <div className="text-[#b9b9b9] overflow-auto">
                        {activity.notes ? activity.notes : "No notes."}
                    </div>
                </div>
            }
            {activity &&
                <div style={{ color: statusColor[activity.currentStatus] }} className='flex flex-nowrap justify-between items-center p-4 my-2 gap-2 bg-[#ededed] rounded-md relative w-max'>
                    <div className={`w-[120px] text-[12px] font-semibold`}>{activity.lastActionDate ? activity.lastActionDate : " - "}</div>
                    {props.adding && props.equipmentList &&
                        <AlertsMultipleSelect
                            idAttr='channel_id'
                            valAttr='channel_name'
                            data={Object.values(props.equipmentList)}
                            dataType='circuits'
                            selectItem={updateActivity}
                            selectedList={selectedPoints}
                            width='w-[150px]'
                            placeholder="Select"
                            deselectAll={true} />
                    }
                    {!props.adding && edit && props.equipmentList && <select
                        onChange={updateActivity}
                        className={`w-[150px] text-[12px] font-semibold overflow-hidden overflow-ellipsis whitespace-nowrap ${!edit ? "bg-[transparent]" : "bg-[white]"}`}
                        disabled={!edit}
                        name="channel_id"
                        value={activity.channel_id && activity.channel_id}>
                        <option value=""> - </option>
                        {
                            Object.keys(props.equipmentList).sort().map((e, id) => (
                                <option key={id + e} value={props.equipmentList[e].channel_id}>{e}</option>
                            ))
                        }
                    </select>}
                    {props.groupsList && <select
                        onChange={updateActivity}
                        className={`w-[150px] text-[12px] font-semibold overflow-hidden overflow-ellipsis whitespace-nowrap ${!edit ? "bg-[transparent]" : "bg-[white]"}`}
                        disabled={!edit}
                        name="type"
                        value={activity.type && activity.type}>
                        <option value=""> - </option>
                        {
                            Object.keys(props.groupsList).map((e, id) => (
                                <option key={id + e} value={e}>{e}</option>
                            ))
                        }
                    </select>}
                    {/* {props.groupsList && <Link className="text-left" to={`/maintenance?building=${context.getBuilding}&group=${activity.maintenance_id}`} target="_blank">
                        <div className="flex flex-nowrap justify-start items-center w-[150px]">
                            <p className={`text-[12px] font-semibold overflow-hidden overflow-ellipsis whitespace-nowrap underline w-[135px]`}>
                                test
                            </p>
                            {GlobalSVG.edit2()}
                        </div>
                    </Link>} */}
                    {!edit && !props.groupsList && <Link className="text-left" to={`/circuit?channel_id=${activity.channel_id}&tab=2`} target="_blank">
                        <div className="flex flex-nowrap justify-start items-center w-[150px]">
                            <p className={`text-[12px] font-semibold overflow-hidden overflow-ellipsis whitespace-nowrap underline w-[135px]`}>
                                {activity.channel_name && activity.channel_name}
                            </p>
                            {GlobalSVG.edit2()}
                        </div>
                    </Link>}
                    <select
                        onChange={updateActivity}
                        className={`w-[120px] text-[12px] font-semibold overflow-hidden overflow-ellipsis whitespace-nowrap ${!edit ? "bg-[transparent]" : "bg-[white]"}`}
                        disabled={!edit}
                        name="timebase"
                        value={activity.timebase && activity.timebase}>
                        <option value=""> - </option>
                        {props.equipmentList && !Object.values(props.equipmentList).some(e => selectedPoints.includes(e.channel_id) && e.untracked) && <option value="runtime">Runtime</option>}
                        <option value="days">Days</option>
                        {props.equipmentList && !Object.values(props.equipmentList).some(e => selectedPoints.includes(e.channel_id) && e.untracked) && <option value="hybrid">Hybrid</option>}
                    </select>
                    <input
                        type="text"
                        onChange={updateActivity}
                        name="threshold_hours"
                        disabled={!edit || activity.timebase === 'days'}
                        className="text-[12px] font-semibold w-[140px] outline-none hide-input-background"
                        value={activity.threshold_hours && activity.threshold_hours} />
                    <input
                        type="text"
                        onChange={updateActivity}
                        name="tolerance_hours"
                        disabled={!edit || activity.timebase === 'days'}
                        className="text-[12px] font-semibold w-[110px] outline-none hide-input-background"
                        value={activity.tolerance_hours && activity.tolerance_hours} />
                    <div className={`w-[100px] text-[12px] font-semibold ${activity.dueInHours || activity.dueInHours === 0 ? "" : "pl-[25px]"}`}>{activity.dueInHours || activity.dueInHours === 0 ? parseInt(activity.dueInHours).toLocaleString() + "h" : " - "}</div>
                    <div className={`w-[110px] text-[12px] font-semibold ${activity.percentHours ? "" : "pl-[25px]"}`}>{activity.percentHours ? parseInt(activity.percentHours * 100).toLocaleString() + "%" : " - "}</div>
                    <input
                        type="text"
                        onChange={updateActivity}
                        name="threshold_days"
                        disabled={!edit || activity.timebase === 'runtime'}
                        className="text-[12px] font-semibold w-[140px] outline-none hide-input-background"
                        value={activity.threshold_days && activity.threshold_days} />
                    <input
                        type="text"
                        onChange={updateActivity}
                        name="tolerance_days"
                        disabled={!edit || activity.timebase === 'runtime'}
                        className="text-[12px] font-semibold w-[110px] outline-none hide-input-background"
                        value={activity.tolerance_days && activity.tolerance_days} />
                    <div className={`w-[100px] text-[12px] font-semibold ${activity.dueInDays || activity.dueInDays === 0 ? "" : "pl-[25px]"}`}>{activity.dueInDays || activity.dueInDays === 0 ? parseInt(activity.dueInDays).toLocaleString() +" days" : " - "}</div>
                    <div className={`w-[110px] text-[12px] font-semibold ${activity.percentDays ? "" : "pl-[25px]"}`}>{activity.percentDays ? parseInt(activity.percentDays * 100).toLocaleString() + "%" : " - "}</div>
                    <div className="">
                        <div className="flex flex-nowrap justify-end items-center">
                            {edit &&
                                (saving ?
                                    <LoaderWheel /> :
                                    <div className="py-[2px] px-2 bg-[#007b4e] text-[white] text-[10px] rounded-[4px] mr-[12px] cursor-pointer" onClick={handleSave}>Save</div>)
                            }
                            {
                                !edit &&
                                <div className='cursor-pointer w-[21px] mr-[4px]' >
                                    <div onClick={() => setShowNote(true)}>{GlobalSVG.info('black')}</div>
                                </div>
                            }
                            {
                                !edit &&
                                <div className='cursor-pointer w-[25px]' onClick={() => setEdit(true)}>
                                    {context.getUserInfo && context.getUserInfo.manage_maintenance_settings && GlobalSVG.edit('black')}
                                </div>
                            }
                            {
                                !edit &&
                                <div className='cursor-pointer w-[25px]'>
                                    {context.getUserInfo && context.getUserInfo.manage_maintenance_settings &&
                                        (deleting ?
                                            <LoaderWheel /> :
                                            <div className='cursor-pointer w-[15px] h-[18px]' onClick={() => handleDelete(activity.id)}>{GlobalSVG.delete()}</div>)
                                    }
                                </div>
                            }
                        </div>

                    </div>

                </div>}
            {
                edit &&
                <textarea
                    data-gramm="false"
                    data-gramm_editor="false"
                    data-enable-grammarly="false"
                    type="text"
                    name="notes"
                    disabled={!edit}
                    placeholder="Notes"
                    className="text-sm text-[#332D41] mb-[10px] w-full outline-none hide-input-background p-[10px]"
                    defaultValue={activity.notes}
                    onChange={updateActivity}></textarea>
            }
        </div>
    )
}
export default MaintenanceActivityLine